import * as React from "react";
const SvgInfoGrey = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#808285", d: "M12 4a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8m0 1.2A6.8 6.8 0 1 1 5.2 12 6.79 6.79 0 0 1 12 5.2M12 8a.8.8 0 1 0 .8.8.8.8 0 0 0-.8-.8m-.009 2.791a.6.6 0 0 0-.591.609v4.4a.6.6 0 1 0 1.2 0v-4.4a.6.6 0 0 0-.609-.609", "data-name": "Group 378512" }));
export default SvgInfoGrey;
